var _path, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgBscBc = function SvgBscBc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1228_77361",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 94,
    height: 94
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H94V94H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1228_77361)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5333 47.0455L13.316 57.2667L3 47.0455L13.3122 36.7333L23.5333 47.0455ZM46.2667 22.6977L63.3725 39.5793L73.4 29.6905L46.2667 3L19.1333 29.7778L29.1609 39.6667L46.2667 22.6977ZM80.6446 36.7333L70.4667 47L80.7352 57.2667L91 47L80.6446 36.7333ZM46.2667 71.3023L29.1609 54.3333L19.1333 64.2258L46.2667 91L73.4 64.2222L63.3725 54.3333L46.2667 71.3023ZM47 57.2667L57.2667 46.9507L47 36.7333L36.7333 47.0417L47 57.2629V57.2667Z",
    fill: "white",
    fillOpacity: 0.2
  }))));
};

export { SvgBscBc as ReactComponent };
export default __webpack_public_path__ + "9d02378aee9af6297e5a664f88264599.svg";